import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ConnectorBuilderPage } from '@/components/connectors/connector-builder';
import { useConnectorStore } from '@/lib/connectors/store';

export const Route = createFileRoute('/_dashboard/connectors/new')({
  component: NewConnectorPage,
});

function NewConnectorPage() {
  const { setCurrentConnector } = useConnectorStore();

  // Initialize with empty connector
  useEffect(() => {
    setCurrentConnector({
      id: '',
      organization_id: '',
      name: '',
      display_name: null,
      description: null,
      icon_url: null,
      documentation_url: null,
      version: '1.0.0',
      is_published: false,
      is_deprecated: false,
      auth_type: 'none',
      auth_config: {},
      base_url: null,
      default_headers: {},
      rate_limit_config: {},
      test_endpoint: null,
      is_public: false,
      marketplace_listing_id: null,
      created_by: '',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    });
  }, [setCurrentConnector]);

  return <ConnectorBuilderPage />;
}
